Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommitmentModalType = void 0;
var CommitmentModalType = exports.CommitmentModalType = function (CommitmentModalType) {
  CommitmentModalType["pending"] = "pending";
  CommitmentModalType["complete"] = "complete";
  CommitmentModalType["existing"] = "existing";
  CommitmentModalType["existingCheck"] = "existingCheck";
  CommitmentModalType["successfulLimit"] = "successfulLimit";
  CommitmentModalType["organizationShare"] = "organizationShare";
  CommitmentModalType["none"] = "none";
  return CommitmentModalType;
}({});